import { Directive, HostListener, Input } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[mtnFormErrorHighlighter]'
})
export class FormErrorHighlighterDirective {

  @Input()
  mtnFormErrorHighlighter: UntypedFormGroup;

  constructor() {
  }

  @HostListener('mouseenter') onHover() {
    if (this.mtnFormErrorHighlighter) {
      this.touchFormControls(this.mtnFormErrorHighlighter);
    }
  }

  private touchFormControls(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      let control: AbstractControl = formGroup.get(key);
      control.markAsTouched();
      control.markAsDirty();

      if (control instanceof UntypedFormGroup) {
        this.touchFormControls(control);
      }
    });
  }
}
